import React from 'react'
import { Datatable } from '../../componants/dataTable/Datatable';

const columns = [
    {
        field: "ENTRY_DT",
        header: "Payment Date",
        align: "center",
        sorting: true
    },
    {
        field: "TOTAL_AMT",
        header: "Total Amount",
        align: "right",
        sorting: true
    },

    {
        field: "DUE_AMT",
        header: "Due Amount",
        align: "right",
        sorting: true
    },
    {
        field: "RECV_AMT",
        header: "Receive Amount",
        align: "right",
        sorting: true
    },
    {
        field: "PAID_AMT",
        header: "Total Paid Amount",
        align: "right",
        sorting: true
    },
    {
        field: "ENTRY_BY",
        header: "Receive By",
        align: "left",
    },
];


const PaymentTbl = ({ data }) => {
    return (
        <Datatable
            data={data}
            columns={columns}
            tableNm="Products & Services"
            pagination={false}
            isSearchBar={false}
            height='auto'
        >
            {(child) => (
                <>

                    {child.column.field === "TOTAL_AMT" && (
                        <>
                            <span> &#8377; {child.row.TOTAL_AMT}</span>
                        </>
                    )}

                    {child.column.field === "PAID_AMT" && (
                        <>
                            <span> &#8377; {child.row.PAID_AMT}</span>
                        </>
                    )}

                    {child.column.field === "DUE_AMT" && (
                        <>
                            <span> &#8377; {child.row.DUE_AMT}</span>
                        </>
                    )}

                    {child.column.field === "RECV_AMT" && (
                        <>
                            <span> &#8377; {child.row.RECV_AMT}</span>
                        </>
                    )}

                    {child.column.field === "TOTAL_RECV_AMT" && (
                        <>
                            <span> &#8377; {child.row.TOTAL_RECV_AMT}</span>
                        </>
                    )}

                    {/* {child.column.field === "CONFIRM_INVOICE" && (
                        <>
                            <span>
                                {child.row.CONFIRM_INVOICE === "Y" &&
                                    "Confirmed"}
                            </span>
                            <span>
                                {child.row.CONFIRM_INVOICE === "N" &&
                                    "Not Confirmed"}
                            </span>
                        </>
                    )}

                    {child.column.field === "PAYMENT_STATUS" && (
                        <>
                            <span className="badge rounded-pill statusBadgeSuccess">
                                {child.row.PAYMENT_STATUS === "Y" && "Paid"}
                            </span>
                            <span className="badge rounded-pill statusBadgeDanger">
                                {child.row.PAYMENT_STATUS === "N" && "Cancel"}
                            </span>
                            <span className="badge rounded-pill statusBadgeWarning">
                                {child.row.PAYMENT_STATUS === "P" &&
                                    "Pending"}
                            </span>
                            <span className="badge rounded-pill statusBadgeWarning">
                                {child.row.PAYMENT_STATUS === "R" &&
                                    "Return"}
                            </span>
                        </>
                    )} */}

                    {/* {child.column.field === 'Action' &&
                        <div className='d-flex justify-content-center gap-2'>
                            <Button variant="edit" title='Download Invoice' className="btn-sm rounded-circle" onClick={() => (
                                invoicegenrate(
                                    child.row.TRAN_CD,
                                    "DIGITAL"
                                ),
                                { state: child.row }
                            )}><BiDownload /></Button>
                            <Button variant="save" title='Payment Details' className="btn-sm rounded-circle" onClick={() => handlepaymentDetail(child.row.TRAN_CD)}><BiMoneyWithdraw /></Button>
                        </div>} */}

                    {
                        child.column.field !== "TOTAL_AMT" &&
                        child.column.field !== "PAID_AMT" &&
                        child.column.field !== "DUE_AMT" &&
                        child.column.field !== "RECV_AMT" &&
                        child.column.field !== "TOTAL_RECV_AMT" &&
                        // child.column.field !== "CONFIRM_INVOICE" &&
                        // child.column.field !== "PAYMENT_STATUS" &&
                        child.row[child.column.field]}
                </>
            )
            }
        </Datatable >
    )
}

export default PaymentTbl;
